module.exports = __webpack_public_path__ + "img/up.45f3ebb2.svg";